var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5263 12.3274V14.2716C9.5736 13.974 8.55397 13.8827 7.55306 14.0054C6.55214 14.1281 5.59916 14.4613 4.77414 14.9769C3.94912 15.4926 3.27615 16.1756 2.81175 16.9688C2.34735 17.7619 2.10507 18.6419 2.10526 19.5349H6.05486e-07C-0.000486822 18.3989 0.293323 17.2779 0.858915 16.2577C1.42451 15.2376 2.24687 14.3454 3.26297 13.6496C4.27908 12.9538 5.46195 12.4728 6.72096 12.2434C7.97996 12.0141 9.28166 12.0434 10.5263 12.3274ZM8.42105 11.1628C4.93158 11.1628 2.10526 8.66512 2.10526 5.5814C2.10526 2.49767 4.93158 0 8.42105 0C11.9105 0 14.7368 2.49767 14.7368 5.5814C14.7368 8.66512 11.9105 11.1628 8.42105 11.1628ZM8.42105 9.30233C10.7474 9.30233 12.6316 7.63721 12.6316 5.5814C12.6316 3.52558 10.7474 1.86047 8.42105 1.86047C6.09474 1.86047 4.21053 3.52558 4.21053 5.5814C4.21053 7.63721 6.09474 9.30233 8.42105 9.30233ZM16.8421 14.8837H20V16.7442H16.8421V20L11.5789 15.814L16.8421 11.6279V14.8837Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponses);
export default __webpack_public_path__ + "static/media/Responses.cd203d0fc55812fdbd414c8e432bcb69.svg";
export { ForwardRef as ReactComponent };